import styled from 'styled-components'

import { Button } from '@blade/ui-kit'
import { PlatformUtil, useClipboard } from '@root/shared'
import { useTranslation } from '@root/shared/localization'
import { Copy2Icon, Share2Icon } from '@root/shared/ui-kit'

type ReferralCodeActionsProps = {
  referralLink: URL
}

export const ReferralCodeActions = (props: ReferralCodeActionsProps) => {
  const { t } = useTranslation()
  const { copyToClipboard } = useClipboard()
  const text = t('referral.share-text') + '\n' + props.referralLink.toString()

  const handleCopyClick = () =>
    copyToClipboard(text, {
      snackbarText: t('referral.code_copied_message'),
    })

  const handleShareClick = () =>
    PlatformUtil.share({
      url: props.referralLink.toString(),
      text: t('referral.share-text'),
    })

  return (
    <Root>
      <ButtonAlt
        variant="soft"
        size="h28"
        radius="rounded"
        onClick={handleCopyClick}
        iconLeft={<Copy2Icon size={12} />}
      >
        {t('common.copy')}
      </ButtonAlt>
      <ButtonAlt
        variant="soft"
        size="h28"
        radius="rounded"
        onClick={handleShareClick}
        iconLeft={<Share2Icon size={12} />}
      >
        {t('common.share')}
      </ButtonAlt>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  justify-content: center;
`

const ButtonAlt = styled(Button)`
  border-radius: 8px;
  /* background: var(--backgroundA-2); */
  backdrop-filter: blur(2px);

  /* color: var(--textA-8); */
  text-align: center;

  font-size: 11px;
  font-weight: 500;
  line-height: 16px;
  min-width: 90px;
`
